import { MODELS_ADD } from 'src/store/ActionTypes';
import CONSTANTS from 'src/store/constants';

const INITIAL_STATE = {
  segments: [],
  fetchSegmentsStatus: undefined,
  fetchSegmentsError: undefined,
  name: null,
};

// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MODELS_ADD.FETCH_SEGMENTS:
      return {
        ...state,
        fetchSegmentsStatus: CONSTANTS.API.STARTED,
      };
    case MODELS_ADD.FETCH_SEGMENTS_SUCCEEDED:
      return {
        ...state,
        segments: action.payload,
        fetchSegmentsStatus: CONSTANTS.API.SUCCEEDED,
      };
    case MODELS_ADD.FETCH_SEGMENTS_FAILED:
      return {
        ...state,
        fetchSegmentsError: action.payload,
        fetchSegmentsStatus: CONSTANTS.API.FAILED,
      };
    case MODELS_ADD.ADD_MODEL:
      return {
        ...state,
        addModelStatus: CONSTANTS.API.STARTED,
      };
    case MODELS_ADD.ADD_MODEL_SUCCEEDED:
      return {
        ...state,
        addModelStatus: CONSTANTS.API.SUCCEEDED,
      };
    case MODELS_ADD.ADD_MODEL_FAILED:
      return {
        ...state,
        addModelStatus: CONSTANTS.API.FAILED,
      };
    case MODELS_ADD.UNSET:
      return {
        ...state,
        addModelStatus: null,
      };
    default:
      return state;
  }
};
